module.exports = __webpack_public_path__ + "static/media/  (21).d0bf18fd.jpg";